export const CIRCLE_OPTIONS = [
  'AP&TS',
  'Bangalore',
  'Bihar, Jharkhand & Orissa',
  'Gujarat, MP & CG',
  'Mumbai',
  'NCR',
  'Punjab',
  'ROK and Goa',
  'Raj & Har',
  'ROK',
  'RoMH',
  'RoMH & Goa',
  'TN&K',
  'Up&UK',
  'WB & NE',
];

export const REGION_OPTIONS = [
  { label: 'North', value: 'North' },
  { label: 'South', value: 'South' },
  { label: 'East', value: 'East' },  
  { label: 'West', value: 'West' },
];

export const FORM_LABELS = {
  siteName: 'Site Name',
  street: 'Street Address',
  pincode: 'Pincode',
  region: 'Region',
  circle: 'Circle',
  city: 'City',
  partOfAOP: 'Part of AOP',
  aopStoreId: 'AOP Store ID',
  relocated: 'Relocated',
  attachments: 'Upload Documents',
  allDocumentsUploaded: 'Do you want to upload all documents now?',
};

export const FORM_PLACEHOLDERS = {
  siteName: 'Enter site name',
  street: 'Enter street address',
  pincode: 'Enter pincode',
  circle: 'Enter circle',
  city: 'Enter city',
  partOfAOP: 'Is the site part of AOP?',
  aopStoreId: 'Enter AOP store ID',
};

export const VALIDATION_ERRORS = {
  siteName: 'Site name is required',
  aopStoreId: 'AOP Store ID is required when approved in AOP',
  allDocumentsUploaded:
    "All documents must be uploaded to proceed to Step 2 — either attach them all or choose 'No' to finish later.",
};
